import { messageHandlerRegistry } from '@reducers/v2/messagesBus/handlerRegistry';
import { MachineMessageType } from '@reducers/v2/messagesBus/types';
import type { OnUpdatedMachineStatusSignalRResponse } from '@interfaces/machines';
import { refreshBatchOnMachineUpdateHandler } from './refreshBatchOnMachineUpdateHandler';

messageHandlerRegistry.register(MachineMessageType.MACHINE_STATUS_UPDATED, ({ message }) =>
  refreshBatchOnMachineUpdateHandler(message.payload as OnUpdatedMachineStatusSignalRResponse)
);
